import { EnvironmentBanner } from "@homebound/beam";
import { getBackendStage } from "src/context";
import { useFeatureFlag } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { FeatureFlagType } from "src/generated/graphqlTypes";
import { useCurrentInternalUserQuery } from "src/queries/user.generated";

export function EnvBanner() {
  const stage = getBackendStage();
  const { data } = useCurrentInternalUserQuery();
  const isImpersonating = data?.currentInternalUser?.user?.isBeingImpersonated;
  // Warns developers (flag-gated) when they are working against live production data.
  const showProdWarning = useFeatureFlag(FeatureFlagType.ProductionWarningBanner);

  return (
    <EnvironmentBanner
      env={stage}
      impersonating={isImpersonating ? { name: data?.currentInternalUser?.name ?? "" } : undefined}
      showProdWarning={showProdWarning}
    />
  );
}
